import { render } from "./Customize.vue?vue&type=template&id=3b163dcc&scoped=true"
import script from "./Customize.vue?vue&type=script&lang=js"
export * from "./Customize.vue?vue&type=script&lang=js"

import "./Customize.vue?vue&type=style&index=0&id=3b163dcc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b163dcc"]])

export default __exports__